
<div *ngIf="!caseLoaded" class="d-flex justify-content-center" style="margin-top: 85px; margin-right: 165px;">
  <div class="spinner-border text-success" style="width: 4rem; height: 4rem;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
  
  <div class="body" *ngIf="caseLoaded">

    <div class="sidebar">
      <app-case-sidebar  [caseId]="caseId" [caseData]="case.caseData"></app-case-sidebar>
    </div>

    <div class="container-fluid">
        <div class="card mt-2 p-2 d-flex flex-row align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <h4 class="m-0">
                    {{caseReference}} - {{case?.caseData?.type?.caseTypeName}} 
                    <span *ngIf="showCaseHeader" class="badge mb-1"
                      [ngClass]="{
                        'bg-danger': caseHeaderAlert,
                        'bg-warning text-dark': caseHeaderWarning,
                        'bg-info text-dark': caseHeaderInfo,
                        'text-white': !caseHeaderWarning && !caseHeaderInfo
                      }"
                      [style.background-color]="caseHeaderColour || null">
                      {{caseHeaderMessage}}
                  </span>
                  <span *ngIf="caseCompleted" class="badge mb-1 bg-success text-white">
                    COMPLETED
                  </span>
                </h4>
            </div>

            <div class="d-flex align-items-center gap-2">

              <h5 class="m-0 me-2 fst-italic text-muted fw-light">{{case.caseData.companyGroupName}}</h5>

                <button *ngIf="case.caseData.klyantMatterId == null" type="button" class="btn btn-secondary"
                    [disabled]="klyantEnabled == false" (click)="loadKlyant()">
                    Save to Klyant
                  </button>
                  <button *ngIf="case.caseData.klyantMatterId != null" type="button" class="btn btn-secondary"
                    [disabled]="klyantEnabled == false" (click)="viewInKlyant()">
                    View in Klyant
                </button>

                <button *ngIf="case.caseData.typeId != 0" type="button" class="btn btn-secondary"
                     (click)="openPortal1Case()">
                    <fa-icon [icon]="faArrowToLeft"></fa-icon>Portal 1
                  </button>

                 <button *ngIf="case.caseData.onHold" type="button" class="btn btn-secondary"
                     (click)="offHoldCase()">
                    <fa-icon [icon]="faPlay"></fa-icon>
                  </button>
                  <button *ngIf="!case.caseData.isCancelled && !case.caseData.onHold && !case.caseData.isCompleted && case.caseData.allocatedToParalegalUser" 
                  type="button" class="btn btn-success"
                     (click)="putCaseOnHold()">
                    <fa-icon [icon]="faPause"></fa-icon>
                </button>

              <button class="btn btn-outline-secondary" (click)="viewArchivedItems()" *ngIf="authService.isPortalManager()">
                <fa-icon [icon]="faHistory"></fa-icon>
              </button>

              <button class="btn" 
               [ngClass]="{
                      'btn-outline-secondary': !caseInfoOpen,
                      'btn-success': caseInfoOpen
                      }"
              (click)="caseInfoOpen = !caseInfoOpen">
                <fa-icon [icon]="faEllipsis"></fa-icon>
              </button>
            </div>
        </div>   

        <!-- main -->
        <div class="row" (dragover)="dragOver($event)" (dragleave)="dragLeave($event)" (drop)="dragDrop($event)">
            <!-- timeline -->
            <div [ngClass]="{
              'col-lg-9': caseInfoOpen,
              'col-lg-12': !caseInfoOpen
              }">

              <div *ngIf="timelineItemsLoading" class="d-flex justify-content-center py-4">
                <div class="spinner-border text-success" style="width: 4rem; height: 4rem;" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>

              <div *ngIf="!timelineItemsLoading">
                  <div class="add-files" *ngIf="showDrop">Add Files</div>

                  <div class="d-flex align-items-center gap-3 mb-2 flex-wrap ms-3 mt-2">

                    <div>
                      <button type="button" 
                              class="btn" 
                              (click)="allowMultiSelect = true" 
                              *ngIf="!allowMultiSelect">
                        <fa-icon [icon]="faCheckSquare" size="lg"></fa-icon>
                      </button>

                      <button type="button" 
                              class="btn" 
                              (click)="cancelMultiSelect()" 
                              *ngIf="allowMultiSelect">
                        <fa-icon [icon]="faTimes" size="lg"></fa-icon>
                      </button>

                      <button type="button" 
                              class="btn btn-outline-secondary" 
                              *ngIf="allowMultiSelect" 
                              [disabled]="!atLeastTwoItemsSelected()" 
                              (click)="onContextMenu($event, null)">
                        <fa-icon [icon]="faEllipsisH" size="lg"></fa-icon>
                      </button>
                    </div>

                     <div class="d-flex align-items-center gap-2 flex-wrap">
                      <label class="form-label mb-0">Show Types:</label>


                      <div ngbDropdown #typesDropdown="ngbDropdown">
                          <button type="button" class="btn btn-outline-secondary btn-sm" ngbDropdownToggle style=" text-align: left;">
                            {{searchType.length == 0 ? '&nbsp; All &nbsp;' : searchType.length + ' selected'}}
                          </button>
                          <div ngbDropdownMenu class="p-2">
                            <div *ngFor="let type of typeOptions" class="form-check">
                              <input type="checkbox" class="form-check-input" [id]="'type_' + type.value"
                                [checked]="searchType.includes(type.value)"
                                (change)="toggleSearchType(type.value)">
                              <label class="form-check-label border-end border-3 ps-2" 
                              [ngClass]="type.class"
                              [for]="'type_' + type.value">{{type.label}}</label>
                            </div>
                          </div>
                        </div>

                        <label class="form-label mb-0 ms-3">Search Text:</label>
                        <input type="text" 
                              class="form-control form-control-sm" 
                              [(ngModel)]="searchString"
                              style="width: 250px;">

                        <button type="button" 
                                class="btn" 
                                (click)="searchTimeline()">
                          <fa-icon [icon]="faSearch"></fa-icon>
                        </button>

                        <button type="button" 
                                class="btn" 
                                (click)="clearSearch()">
                          <fa-icon [icon]="faBackspace"></fa-icon>
                        </button>
                      </div>   

                  </div>

                  <div *ngIf="correspondenceTimelineItems" class="itemList mt-2">
                    <div *ngFor="let item of correspondenceTimelineItems" class="d-flex align-items-center">
                      <div style="width: 20px; min-width: 20px;">
                        <fa-icon *ngIf="item.pinned" [icon]="faThumbtack" size="lg"></fa-icon>
                      </div>
                      <div class="flex-grow-1" 
                          (contextmenu)="onContextMenu($event, item)"
                          (dblclick)="dblClickItem(item)"
                          [ngClass]="{'selectedhighlight': selectedItem === item}">
                        <app-timeline-item #timelineitem [details]="item" [selectable]="allowMultiSelect"></app-timeline-item>
                      </div>
                    </div>
                  </div>

                   <!-- Context menu -->
                  <div style="visibility: hidden; position: fixed"
                      [style.left]="contextMenuPosition.x"
                      [style.top]="contextMenuPosition.y"
                      [matMenuTriggerFor]="contextMenu">
                  </div>

                  <mat-menu #contextMenu="matMenu">
                    <ng-template matMenuContent let-item="item">
                      <span *ngIf="item">
                        <button mat-menu-item (click)="previewDocument(item)" *ngIf="item.caseFile != null && (item.caseFile.format == 1 || item.caseFile.format == 2)">Preview</button>
                        <button mat-menu-item (click)="openRename(item)" *ngIf="item.correspondenceTypeId == 1 || item.correspondenceTypeId == 2 || item.correspondenceTypeId == 3 || item.correspondenceTypeId == 5 || item.correspondenceTypeId == 6">Rename</button>
                        <button mat-menu-item (click)="emailItems(item)" *ngIf="item.correspondenceTypeId == 2 || item.correspondenceTypeId == 3">Email Item</button>
                        <button mat-menu-item (click)="faxItems(item)" *ngIf="item.correspondenceTypeId == 2 || item.correspondenceTypeId == 3">Fax Item</button>
                        <button mat-menu-item (click)="generatePDF(item)" *ngIf="item.correspondenceTypeId == 2 || (item.caseFile != null && item.caseFile.format == 2) || item.correspondenceTypeId == 4 || item.correspondenceTypeId == 5">Generate PDF</button>
                        <button mat-menu-item (click)="pinItem(item)" *ngIf="!item.pinned">Pin Item</button>
                        <button mat-menu-item (click)="unpinItem(item)" *ngIf="item.pinned">Unpin</button>
                        <button mat-menu-item (click)="highlightItem(item)" *ngIf="!item.highlighted">Highlight Item</button>
                        <button mat-menu-item (click)="unhighlightItem(item)" *ngIf="item.highlighted">Unhighlight Item</button>
                        <button mat-menu-item (click)="archiveItems(item)" *ngIf="item.correspondenceTypeId != 9 && item.correspondenceTypeId != 10">Archive Item</button>
                      </span>
                      <span *ngIf="!item">
                        <button mat-menu-item (click)="openPDFStitcher()">Generate PDF</button>
                        <button mat-menu-item (click)="emailItems(null)">Email Items</button>
                        <button mat-menu-item (click)="faxItems(null)">Fax Items</button>
                        <button mat-menu-item (click)="archiveItems(null)">Archive Items</button>
                      </span>
                    </ng-template>
                  </mat-menu>


              </div>



            </div>

            <!-- case info -->
             <div class="col-3 caseInfo" *ngIf="caseInfoOpen">
                <app-info [case]="case"></app-info>
             </div>
        </div>

    </div>

  </div>
